<script setup>
import { onMounted, computed } from "vue";
import CardUserProfile from "@/components/Profile/CardUserProfile.vue";
import { store } from "@/store";

const profile = computed(() => store.user);

onMounted(async () => {
  try {
    store.APP_LOADING = true;
  } catch (error) {
    console.error(error);
  } finally {
    store.APP_LOADING = false;
  }
});
</script>
<template lang="pug">
card-user-profile(:user="profile")
</template>
